import React from "react";
import "./Checkbox.scss";

interface Props {
  value: boolean;
  txt: string;
  id: string;
  onCheck: (e: boolean) => void;
  hasError?: boolean;
  disabled?: boolean;
  ariaLabel?: string;
}

const Checkbox: React.FC<Props> = ({ value, txt, id, onCheck, hasError, disabled, ariaLabel }) => {
  const handleChange = () => {
    onCheck(!value);
  };

  return (
    <div className="checkbox">
      <input
        type="checkbox"
        id={id}
        checked={value}
        className={`checkbox__input ${hasError ? "checkbox__input--error" : ""}`}
        onChange={handleChange}
        disabled={disabled}
        aria-label={ariaLabel}
      />
      <label htmlFor={id} className="checkbox__label">
        {txt}
      </label>
    </div>
  );
};

export default Checkbox;
